// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"804":"4631d002","928":"8578396c","950":"393b18de"}[chunkId] + ".chunk.css";
};